import react, { useEffect, useRef, useState } from "react";
import { Nav } from "../../../layouts/navbar/nav";
import images from "../../../constant/images";
import videos from "../../../constant/videos";
import data2 from "../../../json/data2.json";
import { useTranslation } from "react-i18next";
import Header from "../../../layouts/header";
import { useSelector } from "react-redux";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import React from "react";

export const Iconic = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [type, setType] = useState(null);
  const [isGrouped, setIsGrouped] = useState(false);
  const [categories, setCategories] = useState([]);
  const [uncategorized, setUncategorized] = useState([]);

  useEffect(() => {
    const fetchBestOf = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${baseUrl}/bestoftypes`, {
          params: { name: "Ioniq cup" },
        });

        setType(response.data.type);
        setIsGrouped(response.data.is_grouped || false);
        setCategories(response.data.categories || []);
        setUncategorized(response.data.uncategorized || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load videos. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchBestOf();
  }, [baseUrl]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [video, setVideo] = useState("");

  const renderCategorySwiper = (videosList, categoryId) => {
    return (
      <div className="relative px-4 sm:px-8 lg:px-16">
        <button
          className={`absolute top-1/2 left-[0px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all prev-btn-${categoryId}`}
        >
          <FaAngleLeft />
        </button>

        <button
          className={`absolute top-1/2 right-[0px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all next-btn-${categoryId}`}
        >
          <FaAngleRight />
        </button>

        <Swiper
          spaceBetween={25}
          loop={videosList.length >= 3}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          navigation={{
            prevEl: `.prev-btn-${categoryId}`,
            nextEl: `.next-btn-${categoryId}`,
          }}
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="w-full"
        >
          {videosList?.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="border bg-[#ebebeb] border-black p-4 relative group h-full">
                  <div className="video-container relative h-96 w-full">
                    <video
                      className="video-background absolute inset-0 w-full h-full object-cover"
                      loop
                      muted
                    >
                      <source src={item.url} type="video/mp4" />
                    </video>

                    <div className="video-overlay absolute inset-0 bg-black bg-opacity-60"></div>

                    <div className="absolute inset-0 flex items-center justify-center">
                      <div
                        className="w-16 h-16 cursor-pointer transition-transform duration-300 group-hover:scale-110"
                        onClick={() => {
                          setVideo(item.url);
                          setIsModalOpen(true);
                        }}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="white"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <h3 className="mt-4 text-center text-lg font-medium">
                    {item.name}
                  </h3>
                  <h3 className="mt-4 text-center text-lg font-medium">
                    {item.date}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    );
  };

  return (
    <>
      <div className="flex flex-col gap-[2rem] mb-[5rem]">
        <Header
          image={images.IONIQ}
          title={t(
            "gtm_club_content.tournaments_content.gtm_ionic_content.GTM_IONIQ_Cup"
          )}
        />

        <div className="px-4 sm:px-8 md:px-16 lg:px-[10rem]">
          <p
            className="text-[#5a5a5a] text-base sm:text-lg lg:text-[20px] karla-font leading-relaxed tracking-wide"
            style={{ wordSpacing: "0.2rem" }}
          >
            <span className="font-bold">
              {t("gtm_club_content.tournaments_content.gtm_ionic_content.gtm")}
            </span>{" "}
            {t(
              "gtm_club_content.tournaments_content.gtm_ionic_content.content"
            )}
            <br />
            <br />
            <span>
              {t(
                "gtm_club_content.tournaments_content.gtm_ionic_content.content1"
              )}
            </span>
            <br />
            <br />
            <span className="font-bold">
              {t("gtm_club_content.tournaments_content.gtm_ionic_content.gtm")}
            </span>{" "}
            {t(
              "gtm_club_content.tournaments_content.gtm_ionic_content.content2"
            )}
          </p>
        </div>

        <div className="mt-[5rem] flex flex-col gap-[3rem]">
          {isLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="w-9 h-9 border-4 border-black border-l-transparent rounded-full animate-spin"></div>
            </div>
          ) : error ? (
            <div className="flex justify-center items-center h-64">
              <p className="text-red-500 text-lg karla-font">{error}</p>
            </div>
          ) : isGrouped ? (
            <div className="space-y-16">
              <div className="flex flex-col gap-[1rem]">
                <h1 className="text-center text-4xl custom-font mb-4">
                  Best Of
                </h1>
              </div>
              {categories?.map((category) => {
                if (!category.best_ofs || category.best_ofs.length === 0) return null;
                return (
                  <div key={category.id} className="space-y-6">
                    <h2 className="text-2xl font-bold text-black border-b border-[#ddd] pb-2 px-4 sm:px-8 lg:px-16 custom-font">
                      {category.name}
                    </h2>
                    {renderCategorySwiper(category.best_ofs, category.id)}
                  </div>
                );
              })}
              {uncategorized?.length > 0 && (
                <div className="space-y-6">
                  <h2 className="text-2xl font-bold text-black border-b border-[#ddd] pb-2 px-4 sm:px-8 lg:px-16 custom-font">
                    Other Videos
                  </h2>
                  {renderCategorySwiper(uncategorized, 'uncategorized')}
                </div>
              )}
            </div>
          ) : type?.best_ofs?.length > 0 ? (
            <div className="space-y-12">
              <div className="flex flex-col gap-[2rem]">
                <h1 className="text-center text-4xl custom-font">
                  Best Of
                </h1>
              </div>
              {renderCategorySwiper(type.best_ofs, 'flat')}
            </div>
          ) : (
            <div className="text-center "></div>
          )}
        </div>
        {isModalOpen && (
          <div className="modal fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
            <div className="modal-video relative lg:max-w-[80vw] lg:h-[80vh]  bg-white">
              <button
                className="modal-close absolute -top-12 right-0 text-white text-3xl"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
              <video className="w-full h-full" controls autoPlay src={video}>
                <source src={video} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
